/*
 * Project: LegalPlace assistant
 * File: src/app/refs/step_param.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/

class LpSecondParam {
  constructor() {
    this.value = true; // simple value
    this.is_discovered = false; // does the user saw it
    this.state = 'NONE'; // Payed or not
  }

  isDiscovered() {
    return this.is_discovered;
  }

  setState(state = 'NONE') {
    this.state = state;
  }
}

export default LpSecondParam;



// WEBPACK FOOTER //
// ./src/app/refs/step_param.js